import React from 'react';
import {
    getExportCellValue,
    getExportHeaderText,
    getScrubbedFilenameForExport,
    shouldExportColumn
} from "./agGrid";
import { getFilename as getMsFileName } from '../../market-share/helpers/export';
import { getFilename as getMdFileName } from '../../market-dynamics/helpers/export';
import { getFilename as getAmFileName } from '../../agent-production/agent-movement/helpers/export';
import { getFilename as getADFileName } from '../../agent-production/components/helpers/agentProfile';
import ExportButton from '../components/ExportButton';
import { useCommonStore, useSearchStore } from '../../store/store';
import { downloadFileTypes as dft } from '../../constants';
import { exportModalByRoute } from './routes';
import { usePDFStore } from '../../store/pdf/store';

const getStoreStatuses = () => {
    const fileType = usePDFStore.getState()?.downloadModalStatus?.fileType;
    const exportPdf = useCommonStore.getState()?.handleConvertToPDF;
    const selectedModule = useSearchStore.getState()?.selectedModule;
    const isModalExportRoute = exportModalByRoute.includes(window.location.pathname)
    return { exportPdf, fileType, isModalExportRoute, selectedModule };
};

export const generateFileName = (template, markers) => {
    let filename = template;
    Object.keys(markers).forEach((marker) => {
        filename = filename.replace(marker, markers[marker]);
    });
    return filename;
};

const handleExportAction = ({ gridRef, fileName, isDirectPdf, isTabExport, shouldUsePrimaryColumns }) => {
    const { exportPdf, fileType, isModalExportRoute } = getStoreStatuses();
    const columnDefs =  shouldUsePrimaryColumns
        ? gridRef.current?.columnApi?.api?.columnModel?.primaryColumns
        : gridRef.current?.columnApi?.api?.columnModel?.columnDefs;
    let exportedColumns = [];

    columnDefs?.forEach(col => {
        if (shouldExportColumn(col)) {
            exportedColumns.push(col?.field || col?.colId);
        }
    });
    const exportParams = {
        fileName,
        columnKeys: exportedColumns,
        processCellCallback: getExportCellValue,
        processHeaderCallback: getExportHeaderText,
        skipColumnGroupHeaders: shouldUsePrimaryColumns,
    };
    const exportCsv = () => isTabExport
        ? gridRef?.api?.exportDataAsCsv(exportParams)
        : gridRef.current?.api?.exportDataAsCsv(exportParams);
    if (isDirectPdf || isModalExportRoute && fileType === dft.pdf) exportPdf();
    if (!isModalExportRoute || (isModalExportRoute && fileType === dft.csv)) exportCsv();
};

export const getFileName = exportDetails => {
    const filename = {
        ...getMsFileName(exportDetails),
        ...getMdFileName(exportDetails),
        ...getAmFileName(exportDetails),
        ...getADFileName(exportDetails),
    }[exportDetails.exportType];
    return getScrubbedFilenameForExport(filename);
};

const handleModalExportAction = ({ gridRef, fileName, shouldUsePrimaryColumns }) => {
    usePDFStore.getState().setDownloadModalStatus({
            isOpen: true,
            fileType: dft.csv,
            fileName,
            clickAction: () => handleExportAction({ gridRef, fileName, shouldUsePrimaryColumns }),
    });
};

export const getExportButton = ({
    exportDetails,
    gridRef,
    type,
    isDisabled,
    isDirectPdf,
    isLoading,
    isTabExport,
    shouldUsePrimaryColumns,
    filename,
}) => {
    const handleClick = () => {
        const { isModalExportRoute } = getStoreStatuses();
        const exportFilename = filename || getFileName(exportDetails);
        isModalExportRoute && !isDirectPdf
            ? handleModalExportAction({ gridRef, fileName: exportFilename, shouldUsePrimaryColumns })
            : handleExportAction({ gridRef, fileName: exportFilename, isDirectPdf, isTabExport, shouldUsePrimaryColumns })
    };
    return <ExportButton onClick={handleClick} type={type} isDisabled={isDisabled} isLoading={isLoading}/>;
};

export const getPDFCustomChartProps = ({ chartProps, dataLabelsFontSize, dataLabelsOffsetY, gridPadding, height, xAxisLabelsFontSize }) => ({
    ...chartProps,
    options: {
        ...chartProps.options,
        grid: {
            ...chartProps.options.grid,
            padding: gridPadding || chartProps.options.grid.padding || { top: 0, bottom: 60 }
        },
        xaxis: {
            ...chartProps.options.xaxis,
            labels: {
                ...chartProps.options.xaxis?.labels,
                style: {
                    ...((chartProps.options.xaxis?.labels && chartProps.options.xaxis.labels.style) || {}),
                    fontSize: xAxisLabelsFontSize || chartProps.options.xaxis.labels.style.fontSize || '19px',
                },
                rotate: -45,
                offsetY: 10,
            }
        },
        dataLabels: {
            ...(chartProps.options.dataLabels || {}),
            style: {
                ...(chartProps.options.dataLabels?.style || {}),
                fontSize: dataLabelsFontSize || chartProps.options.dataLabels.style.fontSize || '22px',
            },
            offsetY: (typeof chartProps.options.dataLabels?.offsetY === 'number'
                ? chartProps.options.dataLabels.offsetY
                : dataLabelsOffsetY || chartProps.options.dataLabels.offsetY || -20) - 10,
        }
    },
    height: height || chartProps.height || 700
});
